import { AppStateRecord } from "appRoot/state"

export const getMostRecentErrors = (state: AppStateRecord) => state.get('mostRecentErrors')

export const getIsErrorOverlayVisible = (state: AppStateRecord) => state.get('isErrorOverlayVisible')